import type {
    SupplierControlService,
    ControlSupplier,
    ControlRequest,
    ControlUser,
} from '../types';

/**
 * Supplier Control (internal access management) service.
 *
 * Backend endpoints aren't built yet, so this returns empty data and no-ops on
 * writes. The Control screens are fully wired to these methods and will
 * populate once the real implementation lands here.
 */
export const awsSupplierControlService: SupplierControlService = {
    async listSuppliers(): Promise<ControlSupplier[]> {
        return [];
    },

    async listRequests(): Promise<ControlRequest[]> {
        return [];
    },

    async listUsers(): Promise<ControlUser[]> {
        return [];
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setSiteAccess(email: string, siteId: string, granted: boolean): Promise<void> {
        // No-op until the backend access-management endpoint exists.
    },
};

export default awsSupplierControlService;
